export default __webpack_public_path__ + "static/media/drawing-woman1-focusfill.1122a8e5.svg";